export default function SendIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.442264 6.02741C0.0597636 5.87366 0.0642636 5.64491 0.467764 5.51066L14.7823 0.739158C15.179 0.607158 15.4063 0.829158 15.2953 1.21766L11.2048 15.5322C11.0923 15.9289 10.8485 15.9469 10.667 15.5847L7.25001 8.74991L0.442264 6.02741ZM4.10976 5.87741L8.33676 7.56866L10.6168 12.1302L13.2763 2.82266L4.10901 5.87741H4.10976Z"
        fill="white"
      />
    </svg>
  )
}
